import React from "react";
import styled from "styled-components";
import {
  AlertBanner,
  Box,
  Button,
  Text,
  Heading,
} from "@origin-digital/ods-core";

const FDV_SAFE_URL = "https://www.google.com";

const StyledAlertBanner = styled(AlertBanner)`
  && {
    border-radius: 16px;
    color: ${({ theme }) => theme.palette.neutral.main};
    .MuiAlert-icon svg {
      width: 24px;
      height: 24px;
    }

    .MuiAlert-message h4,
    .MuiAlert-message span {
      color: ${({ theme }) => theme.palette.neutral.main};
    }
  }
`;

const QuickExitButton = styled(Button)`
  && {
    background-color: ${({ theme }) => theme.palette.critical.main};
    border-color: ${({ theme }) => theme.palette.critical.main};
    color: ${({ theme }) => theme.palette.critical.contrastText};
    &:hover {
      background-color: ${({ theme }) => theme.palette.critical.dark};
      border-color: ${({ theme }) => theme.palette.critical.dark};
    }
  }
`;

const handleQuickExit = (): void => {
  window.history.replaceState(null, "", window.location.origin);
};

export const FdvBanner: React.FC = () => (
  <StyledAlertBanner data-id="fdv-banner" tone="critical">
    <Box
      display="flex"
      flexDirection={{ xs: "column", md: "row" }}
      alignItems={{ xs: "flex-start", md: "center" }}
      justifyContent="space-between"
      gap="small"
    >
      <Box display="flex" flexDirection="column" gap="xsmall">
        <Heading data-id="fdv-heading" variant="h4" weight="medium">
          In immediate danger? Call 000
        </Heading>
        <Text>Help is available 24/7.</Text>
      </Box>
      <QuickExitButton
        data-id="fdv-quick-exit"
        href={FDV_SAFE_URL}
        color="secondaryB"
        onClick={handleQuickExit}
      >
        Quick exit
      </QuickExitButton>
    </Box>
  </StyledAlertBanner>
);
